<div class="dot" [style]="{ 'background-color': color }">
  <span>
    {{ number }}
  </span>
</div>
